export const DISTANCE_OPTIONS = [
  { id: '0', labelId: 'onboarding.location.myCityOnly', miles: 0 },
  { id: '5', labelId: null, miles: 5 },
  { id: '10', labelId: null, miles: 10 },
  { id: '25', labelId: null, miles: 25 },
  { id: '50', labelId: null, miles: 50 },
  { id: '100', labelId: null, miles: 100 },
  { id: '200', labelId: null, miles: 200 },
];
